/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { z } from "zod";

export const deleteApiAdminsIdPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор администратора")
    })

/**
 * @description Администратор удален
 */
export const deleteApiAdminsId200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const deleteApiAdminsId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const deleteApiAdminsId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const deleteApiAdminsId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Администратор не найден
 */
export const deleteApiAdminsId404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const deleteApiAdminsId500Schema = z.lazy(() => badResponseModelSchema)

export const deleteApiAdminsIdMutationResponseSchema = z.lazy(() => deleteApiAdminsId200Schema)